import type { TokenResponse } from 'expo-auth-session';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { storage } from '@/configs/storage';
import { AUTH_STORE_KEY } from '@/features/authorization/constants/store';

export type AuthStore = {
  token?: TokenResponse;
  updateToken: (token?: TokenResponse) => void;
  reset: () => void;
};

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      token: undefined,
      updateToken: (token?: TokenResponse) => set({ token: token }),
      reset: () => set({ token: undefined })
    }),
    {
      name: AUTH_STORE_KEY,
      storage: createJSONStorage(() => storage)
    }
  )
);
